import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RewardsWalletService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';
import { Location } from '@angular/common';
@Component({
  selector: 'fgb-lotto-wallet-details-page',
  templateUrl: './lotto-wallet-details-page.component.html',
  styleUrls: ['./lotto-wallet-details-page.component.scss'],
})
export class LottoWalletDetailsPageComponent implements OnInit {
  id: number;

  constructor(private route: ActivatedRoute, private rewardsWalletService: RewardsWalletService, private location: Location) {}

  ngOnInit() {
    this.id = +(this.route.snapshot.paramMap.get('id') || 0);
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
  }

  goBack() {
    this.location.back();
  }
}
